import React from "react";
import { Button } from "cprime-foundational-components";

type CprimeButtonProps = React.ComponentProps<typeof Button>;

const CprimeButton: React.FC<CprimeButtonProps> = (props) => {
  return (
    <Button
      {...props}
      size={props?.size || "medium"}
      sx={{
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: "ToyotaType-Regular",
        ...props.sx,
      }}
    />
  );
};

export default CprimeButton;
